import React, { ReactNode, useState } from 'react';

import { TooltipOffset } from '../tooltips/types';
import { I18nText } from '../../types';
import { Tooltip } from '../tooltips/Tooltip';
import { Translate } from '../Translate';

import { TooltipPlacement } from '../tooltips/tooltipsConstants';

interface TooltipWrapperProps {
  children: ReactNode;
  tooltipI18nText?: I18nText;
  className?: string;
  tooltipClassName?: string;
  boundary?: Element;
  maxWidth?: number | 'none';
  tooltipPlacement?: TooltipPlacement;
  interactive?: boolean;
  withArrow?: boolean;
  withoutOffset?: boolean;
  withoutFollowCursor?: boolean;
}

const offset: TooltipOffset = [-12, 0];

function TooltipWrapper({
  children,
  tooltipI18nText,
  className,
  tooltipClassName,
  boundary,
  maxWidth,
  tooltipPlacement,
  interactive = true,
  withArrow,
  withoutOffset,
  withoutFollowCursor
}: TooltipWrapperProps) {
  const [referenceTooltipElement, setReferenceTooltipElement] =
    useState<HTMLSpanElement | null>(null);

  if (!children) {
    return null;
  }

  return (
    <>
      <span className={className} ref={setReferenceTooltipElement}>
        {children}
      </span>
      <Tooltip
        appendTo={boundary}
        boundary={boundary}
        className={tooltipClassName}
        maxWidth={maxWidth}
        referenceElement={referenceTooltipElement}
        placement={tooltipPlacement}
        interactive={interactive}
        followCursor={withoutFollowCursor ? undefined : 'horizontal'}
        offset={withoutOffset ? undefined : offset}
        withArrow={withArrow}
      >
        {tooltipI18nText ? <Translate id={tooltipI18nText} /> : children}
      </Tooltip>
    </>
  );
}

export default TooltipWrapper;
